var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtc = function SvgBtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 263,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241 262"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.184 37.941V244.6a121.31 121.31 0 0 0 31.249-27.288V65.235a121.307 121.307 0 0 0-31.249-27.288v-.006Z",
    fill: "#FDCC90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.93 24.585v233.358a119.94 119.94 0 0 0 31.249-13.347V37.938A120.051 120.051 0 0 0 151.93 24.58v.006Z",
    fill: "#FCBB6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 20.497V262.04c10.806 0 21.281-1.42 31.249-4.089V24.587a120.653 120.653 0 0 0-31.249-4.09Z",
    fill: "#FBAA48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.422 24.587V257.95a120.662 120.662 0 0 0 31.249 4.089V20.497a120.65 120.65 0 0 0-31.25 4.09Z",
    fill: "#FB971E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.174 37.94v206.658a119.806 119.806 0 0 0 31.249 13.347V24.587a119.738 119.738 0 0 0-31.25 13.36v-.007ZM26.92 65.235v152.082a121.3 121.3 0 0 0 31.249 27.288V37.941a121.297 121.297 0 0 0-31.25 27.288v.006Z",
    fill: "#F88800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.627 116.094H.086v32.424h.128c1.537 26.002 11.296 49.788 26.707 68.792V65.234C15.135 79.775 6.649 97.108 2.627 116.1v-.006Z",
    fill: "#F78700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.434 65.233v152.082c15.41-19.01 25.169-42.79 26.706-68.792l.22-32.419h-2.626c-4.023-18.985-12.509-36.324-24.3-50.865v-.006Z",
    fill: "#FDDBB1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 241.543c66.649 0 120.68-54.073 120.68-120.771C241.36 54.074 187.323 0 120.68 0S0 54.074 0 120.772c0 66.698 54.03 120.771 120.68 120.771Z",
    fill: "url(#btc_svg__a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 234.808c62.933 0 113.951-51.055 113.951-114.037 0-62.982-51.025-114.037-113.951-114.037C57.753 6.734 6.729 57.789 6.729 120.77c0 62.982 51.018 114.037 113.951 114.037Z",
    fill: "url(#btc_svg__b)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.729 226.306c58.225 0 105.417-47.235 105.417-105.503 0-58.267-47.198-105.496-105.417-105.496-58.218 0-105.422 47.235-105.422 105.503 0 58.267 47.198 105.502 105.422 105.502v-.006Z",
    fill: "url(#btc_svg__c)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.891 46.336C161.003 12.423 109.825 6.356 69.754 28.14L213.075 171.57c21.765-40.103 15.704-91.323-18.184-125.235ZM194.89 195.901a106.625 106.625 0 0 0 8.038-9.006L54.44 38.29a106.52 106.52 0 0 0-9 8.045A105.69 105.69 0 0 0 27.104 70.96l143.192 143.296a105.657 105.657 0 0 0 24.6-18.355h-.006Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.26 105.3c2.404-16.077-9.836-24.719-26.573-30.484l5.429-21.778-13.257-3.303-5.285 21.204c-3.485-.869-7.064-1.688-10.622-2.5l5.324-21.344-13.248-3.304-5.433 21.771a437.594 437.594 0 0 1-8.465-1.99l.015-.068-18.281-4.565-3.527 14.16s9.836 2.254 9.629 2.392c5.368 1.34 6.339 4.894 6.178 7.71l-6.185 24.811c.37.094.849.23 1.378.442l-.379-.094-.006-.002a84.685 84.685 0 0 0-1.016-.25l-8.67 34.755c-.656 1.631-2.321 4.079-6.074 3.149.133.193-9.636-2.404-9.636-2.404l-6.581 15.175 17.251 4.3c1.89.474 3.756.961 5.604 1.442l.004.001c1.29.337 2.571.671 3.844.996l-5.486 22.028 13.242 3.303 5.432-21.794c3.618.982 7.128 1.888 10.565 2.742l-5.414 21.691 13.257 3.303 5.486-21.986c22.605 4.278 39.603 2.553 46.758-17.894 5.765-16.462-.287-25.957-12.18-32.149 8.662-1.998 15.187-7.695 16.926-19.464l-.004-.003v.001Zm-30.29 42.472c-3.759 15.103-27.4 8.859-38.217 6.002-.973-.257-1.842-.486-2.583-.67l7.279-29.183c.904.225 2.009.473 3.26.754 11.189 2.511 34.112 7.655 30.262 23.097h-.001Zm-28.016-36.641c9.018 2.407 28.691 7.657 32.117-6.07h.001c3.499-14.04-15.62-18.272-24.957-20.34a113.962 113.962 0 0 1-2.734-.626l-6.6 26.467c.623.155 1.354.351 2.173.569Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.184 37.941V244.6a121.31 121.31 0 0 0 31.249-27.288V65.235a121.307 121.307 0 0 0-31.249-27.288v-.006Z",
    fill: "#FDCC90"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.93 24.585v233.358a119.94 119.94 0 0 0 31.249-13.347V37.938A120.051 120.051 0 0 0 151.93 24.58v.006Z",
    fill: "#FCBB6D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 20.497V262.04c10.806 0 21.281-1.42 31.249-4.089V24.587a120.653 120.653 0 0 0-31.249-4.09Z",
    fill: "#FBAA48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.422 24.587V257.95a120.662 120.662 0 0 0 31.249 4.089V20.497a120.65 120.65 0 0 0-31.25 4.09Z",
    fill: "#FB971E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.174 37.94v206.658a119.806 119.806 0 0 0 31.249 13.347V24.587a119.738 119.738 0 0 0-31.25 13.36v-.007ZM26.92 65.235v152.082a121.3 121.3 0 0 0 31.249 27.288V37.941a121.297 121.297 0 0 0-31.25 27.288v.006Z",
    fill: "#F88800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.627 116.094H.086v32.424h.128c1.537 26.002 11.296 49.788 26.707 68.792V65.234C15.135 79.775 6.649 97.108 2.627 116.1v-.006Z",
    fill: "#F78700"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.434 65.233v152.082c15.41-19.01 25.169-42.79 26.706-68.792l.22-32.419h-2.626c-4.023-18.985-12.509-36.324-24.3-50.865v-.006Z",
    fill: "#FDDBB1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 241.543c66.649 0 120.68-54.073 120.68-120.771C241.36 54.074 187.323 0 120.68 0S0 54.074 0 120.772c0 66.698 54.03 120.771 120.68 120.771Z",
    fill: "url(#btc_svg__d)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68 234.808c62.933 0 113.951-51.055 113.951-114.037 0-62.982-51.025-114.037-113.951-114.037C57.753 6.734 6.729 57.789 6.729 120.77c0 62.982 51.018 114.037 113.951 114.037Z",
    fill: "url(#btc_svg__e)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.729 226.306c58.225 0 105.417-47.235 105.417-105.503 0-58.267-47.198-105.496-105.417-105.496-58.218 0-105.422 47.235-105.422 105.503 0 58.267 47.198 105.502 105.422 105.502v-.006Z",
    fill: "url(#btc_svg__f)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.891 46.336C161.003 12.423 109.825 6.356 69.754 28.14L213.075 171.57c21.765-40.103 15.704-91.323-18.184-125.235ZM194.89 195.901a106.625 106.625 0 0 0 8.038-9.006L54.44 38.29a106.52 106.52 0 0 0-9 8.045A105.69 105.69 0 0 0 27.104 70.96l143.192 143.296a105.657 105.657 0 0 0 24.6-18.355h-.006Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.26 105.3c2.404-16.077-9.836-24.719-26.573-30.484l5.429-21.778-13.257-3.303-5.285 21.204c-3.485-.869-7.064-1.688-10.622-2.5l5.324-21.344-13.248-3.304-5.433 21.771a437.594 437.594 0 0 1-8.465-1.99l.015-.068-18.281-4.565-3.527 14.16s9.836 2.254 9.629 2.392c5.368 1.34 6.339 4.894 6.178 7.71l-6.185 24.811c.37.094.849.23 1.378.442l-.379-.094-.006-.002a84.685 84.685 0 0 0-1.016-.25l-8.67 34.755c-.656 1.631-2.321 4.079-6.074 3.149.133.193-9.636-2.404-9.636-2.404l-6.581 15.175 17.251 4.3c1.89.474 3.756.961 5.604 1.442l.004.001c1.29.337 2.571.671 3.844.996l-5.486 22.028 13.242 3.303 5.432-21.794c3.618.982 7.128 1.888 10.565 2.742l-5.414 21.691 13.257 3.303 5.486-21.986c22.605 4.278 39.603 2.553 46.758-17.894 5.765-16.462-.287-25.957-12.18-32.149 8.662-1.998 15.187-7.695 16.926-19.464l-.004-.003v.001Zm-30.29 42.472c-3.759 15.103-27.4 8.859-38.217 6.002-.973-.257-1.842-.486-2.583-.67l7.279-29.183c.904.225 2.009.473 3.26.754 11.189 2.511 34.112 7.655 30.262 23.097h-.001Zm-28.016-36.641c9.018 2.407 28.691 7.657 32.117-6.07h.001c3.499-14.04-15.62-18.272-24.957-20.34a113.962 113.962 0 0 1-2.734-.626l-6.6 26.467c.623.155 1.354.351 2.173.569Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "btc_svg__a",
    x1: 52.794,
    y1: 11.51,
    x2: 213.552,
    y2: 270.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FEE6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBA63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btc_svg__b",
    x1: 35.627,
    y1: 16.175,
    x2: 212.351,
    y2: 233.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FDD7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FEDDB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btc_svg__c",
    x1: 197.438,
    y1: 218.181,
    x2: 64.488,
    y2: 49.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAA48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDBB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btc_svg__d",
    x1: 52.794,
    y1: 11.51,
    x2: 213.552,
    y2: 270.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FEE6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBA63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btc_svg__e",
    x1: 35.627,
    y1: 16.175,
    x2: 212.351,
    y2: 233.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FDD7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FEDDB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btc_svg__f",
    x1: 197.438,
    y1: 218.181,
    x2: 64.488,
    y2: 49.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAA48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDBB1"
  })))));
};
export { SvgBtc as ReactComponent };
export default __webpack_public_path__ + "static/btc.d4fcbde9.svg";